import React from "react";
import UserProfileIcon from "../sidebar/UserProfileIcon";
import UserProfileDrawer from "../sidebar/UserProfileDrawer";
import { openUserProfileDrawer, useIsRightBarExpanded } from "../../features/Drawer/drawerSlice";
import { useDispatch } from "react-redux";
import { setWilmaState, useRiskViewerStateKind } from "../../features/riskViewer/riskViewerSlice";

const UserProfileElement = () =>
{
    const dispatch = useDispatch();
    const riskViewerStateKind = useRiskViewerStateKind();

    const handleProfileOpen = () =>
    {
        dispatch( openUserProfileDrawer( ) );
        if ( riskViewerStateKind === "selectionState" )
        {
            dispatch( setWilmaState() );
        }
    };
    const isExpanded = useIsRightBarExpanded();


    return (
        <React.Fragment>
            <UserProfileIcon onClick = {handleProfileOpen}/>
            {isExpanded && <UserProfileDrawer/>}
        </React.Fragment>
    );
};

export default UserProfileElement;
